import { add, init } from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { AMPLITUDE_API_KEY } from './constants';

let isInitialized = false;

export const isAmplitudeInitialized = () => {
  return isInitialized;
};

export const initialiseAmplitude = () => {
  if (typeof window === 'undefined') return;

  if (AMPLITUDE_API_KEY == null || AMPLITUDE_API_KEY === '') {
    console.warn('Amplitude API key is not configured. Skipping initialization.');
    return;
  }

  if (isAmplitudeInitialized()) {
    return;
  }

  try {
    init(AMPLITUDE_API_KEY, {
      autocapture: true,
    });

    add(
      sessionReplayPlugin({
        sampleRate: 0.1,
        forceSessionTracking: true,
      })
    );

    isInitialized = true;
  } catch (error) {
    console.error('Error initialising Amplitude', error);
    isInitialized = false;
  }
};
